import { api } from "../api/Middleware";
import {
  APPOINTMENT_TYPES_URL,
  BUSINESS_HOURS_SETTINGS_URL,
  CALENDAR_URL,
} from "../api/Urls";

// Service para gerenciar tipos de atendimento
class AppointmentTypesService {
  // Buscar tipos de atendimento com paginação
  async fetchAppointmentTypes(params = {}) {
    try {
      const response = await api.get(APPOINTMENT_TYPES_URL, { params });
      
      // Se não há parâmetros de paginação, retornar apenas os resultados (compatibilidade)
      if (!params.page && !params.page_size) {
        return response.data.results || response.data || [];
      }
      
      // Retornar estrutura completa com paginação
      return {
        results: response.data.results || [],
        count: response.data.count || 0,
        total_pages: response.data.total_pages || 1,
        current_page: response.data.current_page || 1,
        page_size: response.data.page_size || 20,
        links: response.data.links || {}
      };
    } catch (error) {
      console.error("Erro ao carregar tipos de atendimento:", error);
      throw error;
    }
  }

  // Buscar configurações globais
  async fetchSettings(accountId) {
    try {
      const response = await api.get(BUSINESS_HOURS_SETTINGS_URL, {
        params: { account: accountId },
      });

      const settingsData =
        response.data.results?.[0] || response.data[0] || null;
      return settingsData;
    } catch (error) {
      console.error("Erro ao carregar configurações:", error);
      // Não mostrar erro se for 404 (configurações não existem ainda)
      if (error.response?.status !== 404) {
        console.warn("Configurações não encontradas, usando valores padrão");
      }
      throw error;
    }
  }

  // Salvar configurações globais
  async saveSettings(data, accountId, settingsId = null) {
    try {
      const payload = {
        ...data,
        account: accountId,
      };

      let response;
      if (settingsId) {
        // Atualizar configurações existentes
        response = await api.put(`${BUSINESS_HOURS_SETTINGS_URL}${settingsId}/`, payload);
      } else {
        // Criar novas configurações
        response = await api.post(BUSINESS_HOURS_SETTINGS_URL, payload);
      }

      return response.data;
    } catch (error) {
      console.error("Erro ao salvar configurações:", error);
      throw error;
    }
  }

  // Salvar tipo de atendimento (criar ou atualizar)
  async saveAppointmentType(data, accountId, editingId = null) {
    try {
      const payload = {
        ...data,
        account: accountId,
      };

      let response;
      if (editingId) {
        // Atualizar tipo existente
        response = await api.put(`${APPOINTMENT_TYPES_URL}${editingId}/`, payload);
      } else {
        // Criar novo tipo
        response = await api.post(APPOINTMENT_TYPES_URL, payload);
      }

      return response.data;
    } catch (error) {
      console.error("Erro ao salvar tipo de atendimento:", error);
      throw error;
    }
  }

  // Remover tipo de atendimento
  async deleteAppointmentType(id) {
    try {
      const response = await api.delete(`${APPOINTMENT_TYPES_URL}${id}/`);
      return response.data;
    } catch (error) {
      console.error("Erro ao remover tipo de atendimento:", error);
      throw error;
    }
  }

  // Alternar status ativo/inativo
  async toggleActiveStatus(id) {
    try {
      const response = await api.post(`${APPOINTMENT_TYPES_URL}${id}/toggle_active/`);
      return response.data;
    } catch (error) {
      console.error("Erro ao alterar status:", error);
      throw error;
    }
  }

  // Buscar calendários disponíveis
  async fetchCalendars() {
    try {
      const response = await api.get(CALENDAR_URL);
      const list = response.data.results || response.data;
      return list;
    } catch (error) {
      console.error("Erro ao carregar agendas:", error);
      throw error;
    }
  }
}

// Exportar instância única do service
const appointmentTypesService = new AppointmentTypesService();
export default appointmentTypesService;